export const CARD_COLOR = {
  YELLOW: "YELLOW",
  GREEN: "GREEN",
  BLUE: "BLUE",
};

export const classList = [
  {
    nameOfClass: "Klasse 5 NEU",
    color: CARD_COLOR.YELLOW,
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="86"
        height="84"
        viewBox="0 0 86 84"
        fill="none"
      >
        <path
          d="M43 31C51.2847 31 58 24.0602 58 15.5C58 6.93911 51.2847 0 43 0C34.7159 0 28 6.9398 28 15.5C28 24.0609 34.7159 31 43 31Z"
          fill="#FFAE0D"
        />
        <path
          opacity="0.7"
          d="M13.4726 49.84C20.9133 49.84 26.9452 43.8813 26.9452 36.5309C26.9452 29.1805 20.9133 23.2218 13.4726 23.2218C6.03117 23.2218 0 29.1805 0 36.5309C0 43.8813 6.03117 49.84 13.4726 49.84ZM24.6997 84C32.1412 84 38.1723 78.0413 38.1723 70.6909C38.1723 63.3405 32.1412 57.3818 24.6997 57.3818C17.259 57.3818 11.2272 63.3405 11.2272 70.6909C11.2272 78.0413 17.259 84 24.6997 84ZM61.0757 84C68.5164 84 74.5483 78.0413 74.5483 70.6909C74.5483 63.3405 68.5164 57.3818 61.0757 57.3818C53.635 57.3818 47.6031 63.3405 47.6031 70.6909C47.6031 78.0413 53.635 84 61.0757 84ZM72.5274 49.6182C79.9681 49.6182 86 43.6595 86 36.3091C86 28.9587 79.9681 23 72.5274 23C65.0867 23 59.0548 28.9587 59.0548 36.3091C59.0548 43.6595 65.0867 49.6182 72.5274 49.6182Z"
          fill="#FFC756"
        />
      </svg>
    ),
    text: "Hier findet ihr Übungen für die Klassenstufe 5 für alle Schulformen in verschiedenen Schwierigkeitsgraden.",
    subjects: [
      {
        name: "1 Zahlen und Rechenstrategien",
        href: "",
        topics: [
          {
            name: "1.1 Das Stellenwertsystem",
            href: "https://learning.casio-education.eu/c/#/activities/T351/C143558/C143597",
            items: [
              {
                name: "Zahl",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T351/C143558|C143606/",
              },
              {
                name: "10 mal so viel",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T351/C143558|C143614/",
              },
              {
                name: "Runden",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T351/C143558|C143622/",
              },
              {
                name: "Schätzen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T351/C143558/C143597|C143630",
              },
              {
                name: "Schätzen und Kopfrechnen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T351/C143558/C143597|C143638",
              },
              {
                name: "Kopfrechnen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T351/C143558|C143646/",
              },
              {
                name: "Zahlenmuster",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T351/C143558|C143654/",
              },
              {
                name: "Problemlösungen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T351/C143558|C143663/",
              },
              {
                name: "Große Zahlen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T351/C143558|C143679/",
              },
            ],
          },

          {
            name: "1.2 Addition und Subtraktion",
            href: "https://learning.casio-education.eu/c/#/activities/T351/C143558/C143598",
            items: [
              {
                name: "Strategien zum Kopfrechnen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T351/C143558|C143705/",
              },
              {
                name: "Schriftl. Addition/Subtraktion",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T351/C143558|C143714/",
              },
              {
                name: "Anschauliche Textaufgaben",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T351/C143558|C143723/",
              },
            ],
          },
          {
            name: "1.3 Multiplikation und Division",
            href: "https://learning.casio-education.eu/c/#/activities/T351/C143558/C143599",
            items: [
              {
                name: "Schnelle Fotos",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T351/C143558|C143731/",
              },
              {
                name: "Punktrechung mit 10, 100",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T351/C143558|C143738/",
              },
              {
                name: "Teiler und Faktoren",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T351/C143558|C143744/",
              },
              {
                name: "Multiplikation 1",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T351/C143558|C143750/",
              },
              {
                name: "Multiplikation 2",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T351/C143558|C143757/",
              },
              {
                name: "Punktrechung kombiniert",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T351/C143558|C143764/",
              },
              {
                name: "Division mit Geld",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T351/C143558|C143777/",
              },
              {
                name: "Division mit der Ballonmethode",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T351/C143558|C143783/",
              },
              {
                name: "Kopfrechnen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T351/C143558|C143789/",
              },
            ],
          },
          {
            name: "1.4 Vier Arten von Berechnungen",
            href: "https://learning.casio-education.eu/c/#/activities/T351/C143558/C143600",
            items: [
              {
                name: "Reihenfolge beim Rechnen 1",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T351/C143558|C143796/",
              },
              {
                name: "Reihenfolge beim Rechnen 2",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T351/C143558|C143805/",
              },
              {
                name: "Reihenfolge beim Rechnen 3",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T351/C143558|C143815/",
              },
              {
                name: "Multiplik. mit Flächenmodell 1",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T351/C143558|C143823/",
              },
              {
                name: "Multiplik. mit Flächenmodell 2",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T351/C143558|C143831/",
              },
              {
                name: "Division mit der Ballonmethode",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T351/C143558|C143840/",
              },
              {
                name: "Division mit Geld",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T351/C143558|C143849/",
              },
              {
                name: "Teilung",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T351/C143558|C143857/",
              },
              {
                name: "Anschauliche Textaufgaben",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T351/C143558|C143867/",
              },
              {
                name: "Schnelle Fotos",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T351/C143558|C143875/",
              },
              {
                name: "Division mit der Ballonmethode",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T351/C143558|C143883/",
              },
              {
                name: "Multiplik. mit Flächenmodell 1",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T351/C143558|C143891/",
              },
              {
                name: "Multiplik. mit Flächenmodell 2",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T351/C143558|C143899/",
              },
            ],
          },
        ],
      },

      {
        name: "2 Messen",
        href: "",
        topics: [
          {
            name: "2.1 Kalender",
            href: "https://learning.casio-education.eu/c/#/activities/T351/C143559/C143601",
            items: [
              {
                name: "Rechnen mit dem Kalender",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T351/C143559|C143908/",
              },
              {
                name: "Rechnen mit der Zeit",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T351/C143559|C143915/",
              },
            ],
          },

          {
            name: "2.2 Einheiten",
            href: "https://learning.casio-education.eu/c/#/activities/T351/C143559/C143602",
            items: [
              {
                name: "Umrechnung Länge I",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T351/C143559|C143935/",
              },
              {
                name: "Umrechnung Länge II",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T351/C143559|C143943/",
              },
              {
                name: "Division durch Einheiten",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T351/C143559|C143927/",
              },
              {
                name: "Teilung und Maßteilung L- dL",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T351/C143559|C143951/",
              },
            ],
          },
        ],
      },

      {
        name: "3 Gleichungen und Ungleichungen",
        href: "",
        topics: [
          {
            name: "3.1 Gleichungen",
            href: "https://learning.casio-education.eu/c/#/activities/T351/C143560/C143603",
            items: [
              {
                name: "Bestimme die Zahlen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T351/C143560|C143959/",
              },
              {
                name: "Bestimme die Unbekannte",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T351/C143560|C143965/",
              },
              {
                name: "Gleichungen mit einer Unbek.",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T351/C143560|C143971/",
              },
              {
                name: "Vergleiche",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T351/C143560|C143977/",
              },
            ],
          },
        ],
      },

      {
        name: "4 Wirtschaft und Programmierung",
        href: "",
        topics: [
          {
            name: "4.1 Wirtschaft",
            href: "https://learning.casio-education.eu/c/#/activities/T351/C143561/C143604",
            items: [
              {
                name: "Tabellenkalkulation lernen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T351/C143561|C143983/",
              },
              {
                name: "Einnahmen und Ausgaben",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T351/C143561|C143989/",
              },
            ],
          },
          {
            name: "4.2 Blockprogrammierung",
            href: "https://learning.casio-education.eu/c/#/activities/T351/C143561/C143605",
            items: [
              {
                name: "Schleifen und Begriffe",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T351/C143561|C143995/",
              },
              {
                name: "Variablen und Schleifen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T351/C143561|C143999/",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    nameOfClass: "Klasse 6 NEU",
    color: CARD_COLOR.YELLOW,
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="86"
        height="79"
        viewBox="0 0 86 79"
        fill="none"
      >
        <path
          opacity="0.7"
          d="M29.5713 67.6616C34.3048 67.6616 38.1426 63.7176 38.1426 58.8528C38.1426 53.9881 34.3048 50.0433 29.5713 50.0433C24.8377 50.0433 21 53.9881 21 58.8528C21 63.7176 24.8369 67.6616 29.5713 67.6616ZM58.4287 68C63.1623 68 67 64.0568 67 59.1912C67 54.3265 63.1623 50.3825 58.4287 50.3825C53.6952 50.3825 49.8574 54.3265 49.8574 59.1912C49.8574 64.0568 53.6952 68 58.4287 68ZM43.7983 42.6167C48.5318 42.6167 52.3688 38.6735 52.3688 33.808C52.3688 28.9432 48.5318 25 43.7975 25C39.0639 25 35.2262 28.9432 35.2262 33.808C35.2262 38.6735 39.0639 42.6167 43.7983 42.6167Z"
          fill="#FFD889"
        />
        <path
          d="M43.5 22C49.2988 22 54 17.0749 54 11C54 4.92509 49.2988 0 43.5 0C37.7005 0 33 4.92509 33 11C33 17.0749 37.7005 22 43.5 22Z"
          fill="#FFAE0D"
        />
        <path
          opacity="0.7"
          d="M77.2736 79C82.0928 79 86 75.1942 86 70.5C86 65.805 82.0928 62 77.2736 62C72.4544 62 68.5472 65.805 68.5472 70.5C68.5472 75.1942 72.4544 79 77.2736 79ZM8.72638 79C13.5456 79 17.4536 75.1942 17.4536 70.5C17.4536 65.805 13.5464 62 8.72638 62C3.90716 62 0 65.805 0 70.5C0 75.1942 3.90716 79 8.72717 79H8.72638Z"
          fill="#FFD889"
        />
      </svg>
    ),
    text: "Hier findet ihr Übungen für die Klassenstufe 6 für alle Schulformen in verschiedenen Schwierigkeitsgraden.",
    subjects: [
      {
        name: "1 Bruchrechnung",
        href: "",
        topics: [
          {
            name: "1.1 Grundlagen Brüche",
            href: "https://learning.casio-education.eu/c/#/activities/T352/C143566/C144024",
            items: [
              {
                name: "Einführung in Bruchrechnung",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143566|C144119/",
              },
              {
                name: "Bruchwerte",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143566|C144128/",
              },
              {
                name: "Brüche auf der Zahlengerade",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143566|C144138/",
              },
              {
                name: "Erweitern und Kürzen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143566|C144146/",
              },
              {
                name: "Zeiten und Brüche",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143566|C143921/",
              },
              {
                name: "Brüche größer als 1",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143566|C144155/",
              },
              {
                name: "Bruch als Teil einer Menge",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143566|C144163/",
              },
            ],
          },
          {
            name: "1.2 Rechnungen mit Brüchen I",
            href: "https://learning.casio-education.eu/c/#/activities/T352/C143566/C144025",
            items: [
              {
                name: "Addition und Subtraktion",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143566|C144171/",
              },
              {
                name: "Multiplikation von Brüchen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143566|C144181/",
              },
              {
                name: "Division",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143566|C144189/",
              },
              {
                name: "Textaufgaben",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143566|C144197/",
              },
              {
                name: "Rechnung ohne Visualisierungen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143566|C144205/",
              },
            ],
          },
          {
            name: "1.3 Rechnungen mit Brüchen II",
            href: "https://learning.casio-education.eu/c/#/activities/T352/C143566/C144026",
            items: [
              {
                name: "Größenordnung von Brüchen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143566|C144213/",
              },
              {
                name: "Unechte/gemischte Brüche",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143566|C144221/",
              },
              {
                name: "Brüche kürzen und erweitern",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143566|C144229/",
              },
              {
                name: "Bruch-Strichrechnung",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143566|C144237/",
              },
              {
                name: "Multiplikation von Brüchen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143566|C144244/",
              },
              {
                name: "Division mit gleichem Nenner",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143566|C144252/",
              },
            ],
          },
          {
            name: "1.4 Primzahlen und Faktorisierung",
            href: "https://learning.casio-education.eu/c/#/activities/T352/C143566/C144027",
            items: [
              {
                name: "Faktorisierung",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143566|C144260/",
              },
              {
                name: "Primfaktorzerlegung",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143566|C144268/",
              },
              {
                name: "Bruch kürzen mit Faktoris.",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143566|C144277/",
              },
            ],
          },
        ],
      },
      {
        name: "2 Dezimalzahl",
        href: "",
        topics: [
          {
            name: "2.1 Dezimalzahlen",
            href: "https://learning.casio-education.eu/c/#/activities/T352/C143567/C144028",
            items: [
              {
                name: "Zehner, 100er und 1000er",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143567|C144285/",
              },
              {
                name: "Grundlagen Dezimalzahlen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143567|C144293/",
              },
              {
                name: "Zahlengerade",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143567|C144301/",
              },
            ],
          },
          {
            name: "2.2 Rechnungen mit Dezimalzahlen",
            href: "https://learning.casio-education.eu/c/#/activities/T352/C143567/C144029",
            items: [
              {
                name: "Addition und Subtraktion",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143567|C144309/",
              },
              {
                name: "Kopfrechnen mit Dezimalzahlen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143567|C144317/",
              },
              {
                name: "Multiplikation 1",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143567|C144325/",
              },
              {
                name: "Rechnungen mit 10, 100, 1000",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143567|C144333/",
              },
              {
                name: "Rechnungen mit 0,1 und 0,01",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143567|C144342/",
              },
              {
                name: "Kopfrechen mit Dezimalzahlen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143567|C144351/",
              },
              {
                name: "Multiplikation 2",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143567|C144359/",
              },
              {
                name: "Division",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143567|C144367/",
              },
              {
                name: "Dezimalzahl-Punktrechnung",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143567|C144101/",
              },
              {
                name: "Textaufgaben",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143567|C144375/",
              },
              {
                name: "Platzhalter bestimmen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143567|C144383/",
              },
            ],
          },
        ],
      },
      {
        name: "3 Brüche, Dezimalzahlen und Prozente",
        href: "",
        topics: [
          {
            name: "3.1 Brüche, Dezimalzahlen und Prozente I",
            href: "https://learning.casio-education.eu/c/#/activities/T352/C143568/C144030",
            items: [
              {
                name: "Einfache Dezimalzahlen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143568|C144391/",
              },
              {
                name: "Einführung Brüche und Prozente",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143568|C144397/",
              },
              {
                name: "Zehntel-Brüche und Prozente",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143568|C144403/",
              },
              {
                name: "Brüche, Dezimalz., Prozente",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143568|C144409/",
              },
            ],
          },
          {
            name: "3.2 Brüche, Dezimalzahlen und Prozente II",
            href: "https://learning.casio-education.eu/c/#/activities/T352/C143568/C144031",
            items: [
              {
                name: "Zehntel einer Zahl mit Geld",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143568|C144415/",
              },
              {
                name: "Dezimalz., Brüche, Prozente",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143568|C144424/",
              },
              {
                name: "Prozentrechnung im Kopf",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143568|C144432/",
              },
              {
                name: "Textaufgaben: Brüche, Prozente",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143568|C144440/",
              },
              {
                name: "Dezimalzahlen und Brüche",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143568|C144448/",
              },
            ],
          },
        ],
      },
      {
        name: "4 Geometrie",
        href: "",
        topics: [
          {
            name: "4.1 Formen und Körper",
            href: "https://learning.casio-education.eu/c/#/activities/T352/C143569/C144032",
            items: [
              {
                name: "Eigenschaften von Quadraten",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143569|C144456/",
              },
              {
                name: "Eigenschaften von Dreiecken",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143569|C144464/",
              },
              {
                name: "Textaufgaben: Flächeninh.,Umf.",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143569|C144472/",
              },
              {
                name: "Oberfläche eines Quaders",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143569|C144480/",
              },
              {
                name: "Zylinder, Kegel und Kugel",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143569|C144489/",
              },
              {
                name: "Prismen und Pyramiden",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143569|C144496/",
              },
            ],
          },
          {
            name: "4.2 Symmetrie und Form",
            href: "https://learning.casio-education.eu/c/#/activities/T352/C143569/C144033",
            items: [
              {
                name: "Spiegelung",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143569|C144504/",
              },
              {
                name: "Spiegelung und Symmetrie",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143569|C144512/",
              },
            ],
          },
          {
            name: "4.3 Fläche und Umfang",
            href: "https://learning.casio-education.eu/c/#/activities/T352/C143569/C144034",
            items: [
              {
                name: "Rechteck: Fläche und Umfang",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143569|C144520/",
              },
              {
                name: "Flächeneinheiten",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143569|C144528/",
              },
            ],
          },
          {
            name: "4.4 Volumen und Oberfläche",
            href: "https://learning.casio-education.eu/c/#/activities/T352/C143569/C144035",
            items: [
              {
                name: "Volumeneinheiten Liter",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143569|C144536/",
              },
              {
                name: "Volumeneinheiten Kubik",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143569|C144544/",
              },
              {
                name: "Textaufgaben: Vol., Oberfläche",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143569|C144552/",
              },
            ],
          },
        ],
      },
      {
        name: "5 Messen",
        href: "",
        topics: [
          {
            name: "5.1 Messen mit Einheiten",
            href: "https://learning.casio-education.eu/c/#/activities/T352/C143564/C144021",
            items: [
              {
                name: "Umrechnungen Kg - g",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143564|C144041/",
              },
              {
                name: "Umrechnung Länge, Fläche, Vol.",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143564|C144049/",
              },
              {
                name: "Erste Brüche und Dezimalzahlen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C143564|C144055/",
              },
            ],
          },
        ],
      },
      {
        name: "6 Statistik",
        href: "",
        topics: [
          {
            name: "6.1 Diagramme und Tabellen",
            href: "https://learning.casio-education.eu/c/#/activities/T352/C144019/C144036",
            items: [
              {
                name: "Lesen von Diagr., Tabellen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C144019/C144036|C144560",
              },
              {
                name: "Kuchendiagramm",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C144019|C144569/",
              },
              {
                name: "Verschiedene Darstellungen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C144019|C144577/",
              },
            ],
          },
          {
            name: "6.2 Zentrale Ziele",
            href: "https://learning.casio-education.eu/c/#/activities/T352/C144019/C144037",
            items: [
              {
                name: "Lageparameter (Median ...)",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C144019|C144582/",
              },
              {
                name: "Diagramm und Lageparameter",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C144019|C144590/",
              },
              {
                name: "Lageparameter mit Tabellenk.",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C144019|C144598/",
              },
            ],
          },
          {
            name: "6.3 Lage- und Streuparameter",
            href: "https://learning.casio-education.eu/c/#/activities/T352/C144019/C144038",
            items: [
              {
                name: "Die Spannweite einer Erhebung",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C144019|C144626/",
              },
              {
                name: "Der Modalwert einer Erhebung",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C144019|C144632/",
              },
              {
                name: "Durchschnitt",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C144019|C144638/",
              },
              {
                name: "Median",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C144019|C144644/",
              },
              {
                name: "Lage- und Streuparameter I",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C144019|C144650/",
              },
              {
                name: "Lageparameter interpretieren",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C144019|C144656/",
              },
              {
                name: "Lage- und Streuparameter II",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C144019|C144662/",
              },
            ],
          },
        ],
      },
      {
        name: "7 Programmieren und Geometrie",
        href: "",
        topics: [
          {
            name: "7.1 Geometrie mit Technologie",
            href: "https://learning.casio-education.eu/c/#/activities/T352/C144020/C144039",
            items: [
              {
                name: "Geometrie mit Technologie",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C144020|C144606/",
              },
              {
                name: "Vielecke und Winkel",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C144020|C144610/",
              },
              {
                name: "Kreise mit Technologie",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C144020|C144614/",
              },
            ],
          },
          {
            name: "7.2 Blockprogrammierung",
            href: "https://learning.casio-education.eu/c/#/activities/T352/C144020/C144040",
            items: [
              {
                name: "Schleifen und Begriffe",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C144020|C144618/",
              },
              {
                name: "Geometrische Formen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T352/C144020|C144622/",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    nameOfClass: "Klasse 7 NEU",
    color: CARD_COLOR.YELLOW,
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="86"
        height="86"
        viewBox="0 0 86 86"
        fill="none"
      >
        <path
          d="M43 22C49.0749 22 54 17.0749 54 11C54 4.92509 49.0749 0 43 0C36.9243 0 32 4.92509 32 11C32 17.0749 36.9243 22 43 22Z"
          fill="#FFAE0D"
        />
        <path
          opacity="0.7"
          d="M70.4896 32.5449C75.3316 32.5449 79.2573 28.6177 79.2573 23.7721C79.2573 18.9272 75.3316 15 70.4896 15C65.6476 15 61.722 18.9272 61.722 23.7721C61.722 28.6177 65.6476 32.5449 70.4896 32.5449ZM77.2324 62.1268C82.0752 62.1268 86 58.1997 86 53.3548C86 48.5091 82.0752 44.5812 77.2324 44.5812C72.3904 44.5812 68.4648 48.5091 68.4648 53.3548C68.4648 58.1997 72.3904 62.1268 77.2324 62.1268ZM58.0415 86C62.8835 86 66.8091 82.0728 66.8091 77.2279C66.8091 72.3823 62.8835 68.4551 58.0415 68.4551C53.1995 68.4551 49.2739 72.3823 49.2739 77.2279C49.2739 82.0728 53.1995 86 58.0415 86ZM27.9585 86C32.8005 86 36.7261 82.0728 36.7261 77.2279C36.7261 72.3823 32.8005 68.4551 27.9585 68.4551C23.1165 68.4551 19.1909 72.3823 19.1909 77.2279C19.1909 82.0728 23.1157 86 27.9585 86ZM8.76683 62.3871C13.6096 62.3871 17.5352 58.4592 17.5352 53.6135C17.5352 48.7686 13.6096 44.8414 8.76683 44.8414C3.92483 44.8414 0 48.7686 0 53.6143C0 58.4592 3.92404 62.3871 8.76683 62.3871ZM15.2502 32.5449C20.093 32.5449 24.0186 28.6177 24.0186 23.7721C24.0186 18.9272 20.093 15 15.2502 15C10.409 15 6.48341 18.9272 6.48341 23.7721C6.48341 28.6177 10.409 32.5457 15.251 32.5457L15.2502 32.5449Z"
          fill="#FFD889"
        />
      </svg>
    ),
    text: "Hier findet ihr Übungen für die Klassenstufe 7 für alle Schulformen in verschiedenen Schwierigkeitsgraden.",
    subjects: [
      {
        name: "1 Zahlen und Rechenstrategien",
        href: "",
        topics: [
          {
            name: "1.1 Das Stellenwertsystem",
            href: "https://learning.casio-education.eu/c/#/activities/T353/C144711/C144022",
            items: [
              {
                name: "Zahlen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144711|C143671/",
              },
              {
                name: "Grundrechenarten mit Brüchen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144711|C144061/",
              },
              {
                name: "Dezimalz. und Brüche sortieren",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144711|C144069/",
              },
              {
                name: "Runden",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144711|C144077/",
              },
            ],
          },
          {
            name: "1.2 Muster & problemlösungen",
            href: "https://learning.casio-education.eu/c/#/activities/T353/C144711/C144717",
            items: [
              {
                name: "Zahlenmuster I",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144711|C144729/",
              },
              {
                name: "Zahlenmuster II",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144711|C144085/",
              },
              {
                name: "Zahlenmuster III",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144711|C144738/",
              },
              {
                name: "Problemlösungen I",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144711|C144093/",
              },
              {
                name: "Problemlösungen II",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144711|C143696/",
              },
            ],
          },
          {
            name: "1.3 Zahlengerade",
            href: "https://learning.casio-education.eu/c/#/activities/T353/C144711/C144718",
            items: [
              {
                name: "Einführung negative Zahlen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144711|C144747/",
              },
              {
                name: "Addition/Subtraktion (visual.)",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144711|C144756/",
              },
              {
                name: "Multiplikation (visualisiert)",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144711|C144765/",
              },
              {
                name: "vier Rechenarten",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144711|C144774/",
              },
              {
                name: "Rechenreihenfolge",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144711|C144783/",
              },
              {
                name: "Einfache Textaufgaben",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144711|C144791/",
              },
            ],
          },
          {
            name: "1.4 Negative Zahle",
            href: "https://learning.casio-education.eu/c/#/activities/T353/C144711/C144719",
            items: [
              {
                name: "Negative Zahlen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144711|C144806/",
              },
              {
                name: "Rechnen mithilfe des Zahlenstrahls",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144711|C144814/",
              },
              {
                name: "Subtrahieren",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144711|C144822/",
              },
              {
                name: "Addition/Subtraktion",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144711|C144830/",
              },
              {
                name: "Multiplikation (visual.)",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144711|C144838/",
              },
              {
                name: "vier Rechenarten",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144711|C144846/",
              },
            ],
          },
          {
            name: "1.5 Reihenfolge beim Rechnen",
            href: "https://learning.casio-education.eu/c/#/activities/T353/C144711/C144720",
            items: [
              {
                name: "Rechenreihenfolge I",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144711|C144854/",
              },
              {
                name: "Rechenreihenfolge II",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144711|C144862/",
              },
              {
                name: "Rechenreihenfolge III",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144711|C144870/",
              },
              {
                name: "Rechenreihenfolge IV",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144711|C144881/",
              },
            ],
          },
        ],
      },
      {
        name: "2 Prozent",
        href: "",
        topics: [
          {
            name: "2.1 Prozent",
            href: "https://learning.casio-education.eu/c/#/activities/T353/C144712/C144721",
            items: [
              {
                name: "Einfache Prozentrechnungen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144712|C144891/",
              },
              {
                name: "Ermittlung des Prozentwertes",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144712|C144900/",
              },
              {
                name: "Ermittlung des Prozentsatzes",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144712|C144910/",
              },
              {
                name: "Ermittlung des Prozent- und Grundwertes",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144712|C144918/",
              },
              {
                name: "Textaufgaben",
                href: " https://learning.casio-education.eu/c/#/calculation/t/T353/C144712|C144960",
              },
            ],
          },
          {
            name: "2.2 Prozent, Bruch & Dezimalzahl",
            href: "https://learning.casio-education.eu/c/#/activities/T353/C144712/C144722",
            items: [
              {
                name: "Prozent, Bruch und Dezimalzahl I",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144712|C144934/",
              },
              {
                name: "Prozent, Bruch und Dezimalzahl II",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144712|C144943/",
              },
              {
                name: "Prozent, Bruch und Dezimalzahl III",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144712|C144952/",
              },
              {
                name: "Textaufgaben",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144712|C144960/",
              },
            ],
          },
        ],
      },
      {
        name: "3 Gleichungen",
        href: "",
        topics: [
          {
            name: "3.1 Gleichungen",
            href: "https://learning.casio-education.eu/c/#/activities/T353/C144713/C144723",
            items: [
              {
                name: "Bestimme die Unbekannte",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144713|C144968/",
              },
              {
                name: "Gleichungen im Waagemodell I",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144713|C144976/",
              },
              {
                name: "Gleichungen im Blockmodell",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144713|C144985/",
              },
              {
                name: "Gleichungen im Waagemodell II",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144713|C144994/",
              },
              {
                name: "Textaufgaben mit Gleichungen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144713|C145003/",
              },
            ],
          },
        ],
      },
      {
        name: "4 Wahrscheinlichkeits",
        href: "",
        topics: [
          {
            name: "4.1 Wahrscheinlichkeiten",
            href: "https://learning.casio-education.eu/c/#/activities/T353/C144714/C144724",
            items: [
              {
                name: "Wahrscheinlichkeit von Würfeln",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144714|C145011/",
              },
              {
                name: "Wahrscheinlichkeit",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144714|C145018/",
              },
              {
                name: "Kombinatorik",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144714|C145024/",
              },
            ],
          },
        ],
      },
      {
        name: "5 Geometrie",
        href: "",
        topics: [
          {
            name: "5.1 Symmetrie und Form",
            href: "https://learning.casio-education.eu/c/#/activities/T353/C144715/C144725",
            items: [
              {
                name: "Kongruente Figuren",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144715|C145031/",
              },
            ],
          },
          {
            name: "5.2 Fläche und Umfang",
            href: "https://learning.casio-education.eu/c/#/activities/T353/C144715/C144726",
            items: [
              {
                name: "Winkel und Winkelsummen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144715|C145053/",
              },
              {
                name: "Flächeninhalt von Dreiecken I",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144715|C145061/",
              },
              {
                name: "Flächeninhalt von Dreiecken II",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144715|C145069/",
              },
              {
                name: "Besondere Dreiecke",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144715|C145076/",
              },
              {
                name: "Rechtecke und Dreiecke",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144715|C145083/",
              },
              {
                name: "Flächeninhalt und Umfang von zusammengesetzten Figuren",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144715|C145091/",
              },
              {
                name: "besondere Vierecke",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144715|C145099/",
              },
              {
                name: "Flächeninhalt des Trapez",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144715|C145107/",
              },
              {
                name: "Flächeninhalt von Parallelogramm und Trapez",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144715|C145116/",
              },
            ],
          },
        ],
      },
      {
        name: "6 Wirtschaft und Programmierung",
        href: "",
        topics: [
          {
            name: "6.1 Tabellenkalkulationen",
            href: "https://learning.casio-education.eu/c/#/activities/T353/C144716/C144727",
            items: [
              {
                name: "Tabellenkalkulation",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144716|C145039/",
              },
              {
                name: "Budget und Konten",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144716|C145045/",
              },
            ],
          },
          {
            name: "6.2 Programmieren",
            href: "https://learning.casio-education.eu/c/#/activities/T353/C144716/C144728",
            items: [
              {
                name: "Schleifen und Begriffe",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T353/C144716|C145049/",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    nameOfClass: "Klasse 8 NEU",
    color: CARD_COLOR.GREEN,
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="86"
        height="62"
        viewBox="0 0 86 62"
        fill="none"
      >
        <path
          opacity="0.7"
          d="M7.5652 15.1008C11.7438 15.1008 15.1311 11.7202 15.1311 7.54973C15.1311 3.37995 11.7438 0 7.5652 0C3.38725 0 0 3.37995 0 7.55041C0 11.7202 3.38657 15.1008 7.5652 15.1008ZM7.78897 38.1034C11.9676 38.1034 15.3549 34.7235 15.3549 30.5537C15.3549 26.3832 11.9676 23.0026 7.78897 23.0026C3.61102 23.0026 0.224453 26.3832 0.224453 30.5537C0.224453 34.7235 3.61102 38.1034 7.78897 38.1034ZM78.4348 38.5501C82.6128 38.5501 86 35.1701 86 30.9997C86 26.8299 82.6128 23.4499 78.4348 23.4499C74.2569 23.4499 70.8696 26.8299 70.8696 30.9997C70.8696 35.1701 74.2569 38.5501 78.4348 38.5501ZM78.4348 62C82.6128 62 86 58.62 86 54.4503C86 50.2798 82.6128 46.8999 78.4348 46.8999C74.2569 46.8999 70.8696 50.2798 70.8696 54.4503C70.8696 58.62 74.2569 62 78.4348 62ZM31.0611 15.1008C35.239 15.1008 38.6263 11.7202 38.6263 7.54973C38.6263 3.37995 35.239 0 31.0604 0C26.8831 0 23.4959 3.37995 23.4959 7.55041C23.4959 11.7202 26.8824 15.1008 31.0611 15.1008ZM31.0611 38.3404C35.239 38.3404 38.6263 34.9597 38.6263 30.7893C38.6263 26.6202 35.239 23.2395 31.0604 23.2395C26.8831 23.2395 23.4959 26.6202 23.4959 30.7899C23.4959 34.9597 26.8824 38.3404 31.0611 38.3404ZM54.939 62C59.1169 62 62.5042 58.62 62.5042 54.4503C62.5042 50.2798 59.1169 46.8999 54.9383 46.8999C50.761 46.8999 47.3737 50.2798 47.3737 54.4503C47.3737 58.62 50.761 62 54.939 62Z"
          fill="#63D7BD"
        />
        <path
          d="M54.5 40C59.7465 40 64 35.7465 64 30.5C64 25.2535 59.7465 21 54.5 21C49.2535 21 45 25.2535 45 30.5C45 35.7465 49.2535 40 54.5 40Z"
          fill="#20C5A0"
        />
      </svg>
    ),
    text: "Hier findet ihr Übungen für die Klassenstufe 8 für alle Schulformen in verschiedenen Schwierigkeitsgraden.",
    subjects: [
      {
        name: "1 Zahlen und Rechenstrategien",
        href: "",
        topics: [
          {
            name: "1.1 Kopfrechnen",
            href: "https://learning.casio-education.eu/c/#/activities/T354/C145138/C145145",
            items: [
              {
                name: "Kopfrechnen Multiplikation I",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145138|C145163/",
              },
              {
                name: "Kopfrechnen Multiplikation II",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145138|C145172/",
              },
              {
                name: "Kopfrechnen Multiplikation (Flächenmodell)",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145138|C145181/",
              },
              {
                name: "Kopfrechnen Prozente I",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145138|C145190/",
              },
              {
                name: "Kopfrechnen Prozente II",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145138|C145198/",
              },
              {
                name: "Kopfrechnen Division (Blockmethode)",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145138|C145206/",
              },
              {
                name: "Runden",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145138|C145212/",
              },
            ],
          },
        ],
      },
      {
        name: "2 Algebra I",
        href: "",
        topics: [
          {
            name: "2.1 Terme und Variablen",
            href: "https://learning.casio-education.eu/c/#/activities/T354/C145139/C145146",
            items: [
              {
                name: "Von Zahlen zu Buchstaben",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145139|C145221/",
              },
              {
                name: "Variablen zusammenfassen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145139|C145229/",
              },
              {
                name: "Terme bilden",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145139|C145237/",
              },
              {
                name: "Termumformungen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145139|C145245/",
              },
            ],
          },
          {
            name: "2.2 Rechnen mit Variablen",
            href: "https://learning.casio-education.eu/c/#/activities/T354/C145139/C145147",
            items: [
              {
                name: "Addition von Variablen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145139|C145253/",
              },
              {
                name: "Ausklammern (Faktorisieren)",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145139|C145264/",
              },
              {
                name: "Klammern auflösen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145139|C145272/",
              },
              {
                name: "Multiplikation von Termen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145139|C145281/",
              },
              {
                name: "Vereinfachen von Termen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145139|C145292/",
              },
            ],
          },
          {
            name: "2.3 Spezialisierung in der Algebra",
            href: "https://learning.casio-education.eu/c/#/activities/T354/C145139/C145148",
            items: [
              {
                name: "Faktorisierung von Termen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145139|C145356/",
              },
              {
                name: "Faktorisierung von Summen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145139|C145367/",
              },
            ],
          },
        ],
      },
      {
        name: "3 Gleichungen I",
        href: "",
        topics: [
          {
            name: "3.1 Kurze Gleichungen",
            href: "https://learning.casio-education.eu/c/#/activities/T354/C145140/C145150",
            items: [
              {
                name: "Finde die Unbekannte",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145140|C145399/",
              },
              {
                name: "einfache Gleichungen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145140|C145406/",
              },
              {
                name: "einfache Textaufgaben",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145140|C145414/",
              },
              {
                name: "einfache Gleichungen ohne Hilfen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145140|C145420/",
              },
            ],
          },
          {
            name: "3.2 Längere Gleichungen",
            href: "https://learning.casio-education.eu/c/#/activities/T354/C145140/C145151",
            items: [
              {
                name: "Gleichungen mit Waagemodell",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145140|C145428/",
              },
              {
                name: "Gleichungen ohne Hilfen I",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145140|C145436/",
              },
              {
                name: "komplexere Gleichungen I",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145140|C145444/",
              },
              {
                name: "komplexere Gleichungen II",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145140|C145450/",
              },
              {
                name: "Textaufgaben I",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145140|C145456/",
              },
              {
                name: "Gleichungen ohne Hilfen II",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145140|C145462/",
              },
            ],
          },
          {
            name: "3.3 Gleichungen mit Klammer",
            href: "https://learning.casio-education.eu/c/#/activities/T354/C145140/C145152",
            items: [
              {
                name: "Gleichungen mit Klammern",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145140|C145470/",
              },
              {
                name: "Textaufgaben II",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145140|C145476/",
              },
              {
                name: "Gleichungn ohne Hilfen III",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145140|C145483/",
              },
            ],
          },
          {
            name: "3.4 Quadratische Gleichungen",
            href: "https://learning.casio-education.eu/c/#/activities/T354/C145140/C145153",
            items: [
              {
                name: "Quadratische Gleichungen mit Hilfen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145140|C145491/",
              },
              {
                name: "Quadratische Gleichungen ohne Hilfen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145140|C145497/",
              },
            ],
          },
          {
            name: "3.5 Bruchgleichungen",
            href: "https://learning.casio-education.eu/c/#/activities/T354/C145140/C145154",
            items: [
              {
                name: "Bruchgleichungen mit Waagemodell",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145140|C145503/",
              },
              {
                name: "Bruchgleichungen ohne Hilfen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145140|C145507/",
              },
            ],
          },
        ],
      },
      {
        name: "4 Funktionen I",
        href: "",
        topics: [
          {
            name: "4.1 Die Beziehung zwischen x und f(x)",
            href: "https://learning.casio-education.eu/c/#/activities/T354/C145141/C145155",
            items: [
              {
                name: "Das Koordinatensystem",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145141|C145513/",
              },
              {
                name: "Funktionale Maschinen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145141|C145521/",
              },
              {
                name: "Funktionsterme nutzen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145141|C145529/",
              },
              {
                name: "Funktionsterme bestimmen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145141|C145537/",
              },
              {
                name: "Funktionsterme bestimmen und nutzen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145141/C145155|C145545",
              },
              {
                name: "Funktionsgraphen lesen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145141|C145554/",
              },
              {
                name: "Term linearer Funktionen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145141|C145561/",
              },
            ],
          },
          {
            name: "4.2 Funktionen mit Technologie",
            href: "https://learning.casio-education.eu/c/#/activities/T354/C145141/C145156",
            items: [
              {
                name: "GeoGebra nutzen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145141|C145569/",
              },
              {
                name: "Funktionen in GeoGebra zeichnen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145141|C145573/",
              },
              {
                name: "Schnittpunkte mit Geogebra finden",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145141|C145579/",
              },
              {
                name: "Anwendungsaufgaben",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145141|C145583/",
              },
            ],
          },
        ],
      },
      {
        name: "5 Messen",
        href: "",
        topics: [
          {
            name: "5.1 Umrechnung von Einheiten",
            href: "https://learning.casio-education.eu/c/#/activities/T354/C145142/C145157",
            items: [
              {
                name: "Umrechnung von Einheiten",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145142|C145588/",
              },
              {
                name: "Weg und Geschwindigkeit",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145142|C145596/",
              },
              {
                name: "Umrechnung Geschwindigkeit",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145142|C145600/",
              },
              {
                name: "Masse und Dichte",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145142|C145606/",
              },
            ],
          },

          {
            name: "5.2 Messen in der Wissenschaft",
            href: "https://learning.casio-education.eu/c/#/activities/T354/C145142/C145158",
            items: [
              {
                name: "Beschleunigung",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145142|C145610/",
              },
              {
                name: "Arbeit und Leistung",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145142|C145614/",
              },
              {
                name: "Masse und Schwerkraft",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145142|C145618/",
              },
            ],
          },
        ],
      },
      {
        name: "6 Algebra II",
        href: "",
        topics: [
          {
            name: "6.1 Multiplikation von Polynomen",
            href: "https://learning.casio-education.eu/c/#/activities/T354/C145143/C145159",
            items: [
              {
                name: "Terme erstellen/vereinfachen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145143|C145622/",
              },
              {
                name: "Multiplikation zweier Klammern I",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145143|C145630/",
              },
              {
                name: "Multiplikation zweier Klammern II",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145143|C145637/",
              },
            ],
          },
          {
            name: "6.2 Faktorisierung von Polynomen",
            href: "https://learning.casio-education.eu/c/#/activities/T354/C145143/C145160",
            items: [
              {
                name: "Faktorisierung eines Produkts",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145143|C145643/",
              },
              {
                name: "Faktorisierung einer Summe",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145143|C145654/",
              },
              {
                name: "Binomische Formeln",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145143|C145662/",
              },
              {
                name: "Kürzen von Bruchtermen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145143|C145668/",
              },
            ],
          },
        ],
      },
      {
        name: "7 Funktionen II",
        href: "",
        topics: [
          {
            name: "7.1 Graphen- und Funktionsausdruck",
            href: "https://learning.casio-education.eu/c/#/activities/T354/C145144/C145161",
            items: [
              {
                name: "Funktionsterm einer Geraden",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145144|C145300/",
              },
              {
                name: "Funktionsterm bestimmen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145144|C145308/",
              },
              {
                name: "Vom Funktionsterm zum Graphen I",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145144|C145314/",
              },
              {
                name: "Vom Funktionsterm zum Graphen II",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145144|C145324/",
              },
              {
                name: "Vom Graphen zum Funktionsterm",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145144|C145331/",
              },
            ],
          },
          {
            name: "7.2 Modellieren",
            href: "https://learning.casio-education.eu/c/#/activities/T354/C145144/C145162",
            items: [
              {
                name: "Zeichne Funktionen mit GeoGebra",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145144|C145338/",
              },
              {
                name: "Schnittpunkte mit GeoGebra",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T354/C145144|C145344/",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    nameOfClass: "Klasse 9 NEU",
    color: CARD_COLOR.GREEN,
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="86"
        height="77"
        viewBox="0 0 86 77"
        fill="none"
      >
        <path
          opacity="0.7"
          d="M7.12021 75.7868C11.0531 75.7868 14.2411 72.5706 14.2411 68.6027C14.2411 64.6342 11.0531 61.418 7.12021 61.418C3.18801 61.418 0 64.6342 0 68.6027C0 72.5706 3.18737 75.7868 7.12021 75.7868ZM29.0234 76C32.9556 76 36.143 72.7831 36.143 68.8153C36.143 64.8468 32.9556 61.6305 29.0234 61.6305C25.0906 61.6305 21.9026 64.8468 21.9026 68.8153C21.9026 72.7831 25.0906 76 29.0234 76ZM18.0718 56.6603C22.004 56.6603 25.192 53.4441 25.192 49.4762C25.192 45.5077 22.004 42.2908 18.0712 42.2908C14.1396 42.2908 10.9516 45.5077 10.9516 49.4762C10.9516 53.4441 14.1396 56.6603 18.0718 56.6603ZM30.9189 33.496C34.8511 33.496 38.0391 30.2797 38.0391 26.3113C38.0391 22.3434 34.8511 19.1272 30.9183 19.1272C26.986 19.1272 23.7987 22.3434 23.7987 26.3119C23.7987 30.2797 26.9867 33.496 30.9189 33.496ZM52.8221 33.7085C56.7543 33.7085 59.9423 30.4923 59.9423 26.5244C59.9423 22.5559 56.7543 19.339 52.8221 19.339C48.8899 19.339 45.7019 22.5559 45.7019 26.5244C45.7019 30.4923 48.8899 33.7085 52.8221 33.7085ZM41.8705 14.3695C45.8033 14.3695 48.9914 11.1532 48.9914 7.1854C48.9914 3.21691 45.8033 0 41.8705 0C37.9383 0 34.7503 3.21691 34.7503 7.1854C34.7503 11.1532 37.9377 14.3695 41.8705 14.3695ZM54.9282 75.7868C58.861 75.7868 62.0484 72.5706 62.0484 68.6027C62.0484 64.6342 58.861 61.418 54.9282 61.418C50.996 61.418 47.808 64.6342 47.808 68.6027C47.808 72.5706 50.996 75.7868 54.9282 75.7868ZM65.8798 56.6603C69.812 56.6603 73 53.4441 73 49.4762C73 45.5077 69.812 42.2908 65.8798 42.2908C61.9476 42.2908 58.7596 45.5077 58.7596 49.4762C58.7596 53.4441 61.9476 56.6603 65.8798 56.6603Z"
          fill="#63D7BD"
        />
        <path
          d="M77 77C81.9704 77 86 73.1943 86 68.5C86 63.8057 81.9704 60 77 60C72.0296 60 68 63.8057 68 68.5C68 73.1943 72.0296 77 77 77Z"
          fill="#20C5A0"
        />
      </svg>
    ),
    text: "Hier findet ihr Übungen für die Klassenstufe 9 für alle Schulformen in verschiedenen Schwierigkeitsgraden.",
    subjects: [
      {
        name: "1 Geometrie",
        href: "",
        topics: [
          {
            name: "1.1 Muster",
            href: "https://learning.casio-education.eu/c/#/activities/T355/C145674/C145681",
            items: [
              {
                name: "Mustererkennung I",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145674|C145695/",
              },
              {
                name: "Mustererkennung II",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145674/C145681|C145702",
              },
            ],
          },
          {
            name: "1.2 Fläche und Umfang",
            href: "https://learning.casio-education.eu/c/#/activities/T355/C145674/C145682",
            items: [
              {
                name: "Umfang: Kreis",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145674|C145710/",
              },
              {
                name: "Fläche und Umfang: Kreis",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145674|C145718/",
              },
              {
                name: "Satz des Thales",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145674|C145726/",
              },
            ],
          },
          {
            name: "1.3 Satz des Pythagoras",
            href: "https://learning.casio-education.eu/c/#/activities/T355/C145674/C145683",
            items: [
              {
                name: "Rechtwinklige Dreiecken",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145674|C145732/",
              },
              {
                name: "Satz des Pythagoras I",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145674|C145739/",
              },
              {
                name: "Satz des Pythagoras II",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145674|C145758/",
              },
              {
                name: "Pythagoras - Beweis",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145674|C145747/",
              },
              {
                name: "Satz des Pythagoras - Anwendung",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145674|C145752/",
              },
            ],
          },
          {
            name: "1.4 Oberfläche und Volumen",
            href: "https://learning.casio-education.eu/c/#/activities/T355/C145674/C145684",
            items: [
              {
                name: "Länge, Fläche, Volumen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145674|C145763/",
              },
              {
                name: "Volumen: gerade Prismen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145674|C145769/",
              },
              {
                name: "Volumen: Zylinder",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145674|C145777/",
              },
              {
                name: "Fläche: Prismen und Zylinder",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145674|C145783/",
              },
              {
                name: "Formeln umstellen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145674|C145789/",
              },
            ],
          },
        ],
      },
      {
        name: "2 Ähnlichkeit und Karten",
        href: "",
        topics: [
          {
            name: "2.1 Ähnlichkeit",
            href: "https://learning.casio-education.eu/c/#/activities/T355/C145675/C145685",
            items: [
              {
                name: "Ähnliche Dreiecke I",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145675|C145795/",
              },
              {
                name: "Ähnliche Dreiecke II",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145675|C145803/",
              },
              {
                name: "Ähnliche Dreiecke III",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145675|C145810/",
              },
              {
                name: "Ähnliche Dreiecke IV",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145675|C145816/",
              },
              {
                name: "Ähnlichkeit und Pythagoras",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145675|C145822/",
              },
            ],
          },
          {
            name: "2.2 Karten",
            href: "https://learning.casio-education.eu/c/#/activities/T355/C145675/C145686",
            items: [
              {
                name: "Karten und Maßstab",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145675|C145830/",
              },
            ],
          },
        ],
      },
      {
        name: "3 Statistik",
        href: "",
        topics: [
          {
            name: "3.1 Darstellungen der Statistik",
            href: "https://learning.casio-education.eu/c/#/activities/T355/C145676/C145687",
            items: [
              {
                name: "Diagramme zeichnen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145676|C145838/",
              },
              {
                name: "Statistiken interpretieren",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145676|C145844/",
              },
              {
                name: "Manipulationen in Diagrammen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145676|C145850/",
              },
            ],
          },
        ],
      },
      {
        name: "4 Wahrscheinlichkeitsrechnung",
        href: "",
        topics: [
          {
            name: "4.1 Wahrscheinlichkeit",
            href: "https://learning.casio-education.eu/c/#/activities/T355/C145677/C145688",
            items: [
              {
                name: "einstufige Zufallsversuche",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145677|C145856/",
              },
              {
                name: "zweistufige Zufallsversuche",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145677|C145864/",
              },
              {
                name: "Ziehen mit Zurücklegen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145677|C145872/",
              },
              {
                name: "Ziehen ohne Zurücklegen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145677|C145880/",
              },
              {
                name: "Wahrscheinlichkeiten berechnen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145677|C145888/",
              },
            ],
          },
          {
            name: "4.2 Kombinatorik",
            href: "https://learning.casio-education.eu/c/#/activities/T355/C145677/C145689",
            items: [
              {
                name: "Anzahl Kombinationen I",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145677|C145896/",
              },
              {
                name: "Kombinatorik mit Baumdiagramm",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145677|C145900/",
              },
              {
                name: "Anzahl Kombinationen II",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145677|C145904/",
              },
              {
                name: "Vierfeldertafel",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145677|C145908/",
              },
              {
                name: "Werfen mit zwei Würfeln",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145677|C145912/",
              },
            ],
          },
        ],
      },
      {
        name: "5 Zahlen und Rechenstrategien",
        href: "",
        topics: [
          {
            name: "5.1 Potenzen und Wurzeln",
            href: "https://learning.casio-education.eu/c/#/activities/T355/C145678/C145690",
            items: [
              {
                name: "Quadratzahlen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145678|C145918/",
              },
              {
                name: "Quadratische Gleichungen I",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145678|C145926/",
              },
              {
                name: "Quadratische Gleichungen II",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145678|C145934/",
              },
              {
                name: "Wissenschaftliche Schreibweise",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145678|C145943/",
              },
            ],
          },
        ],
      },
      {
        name: "6 Gleichungen",
        href: "",
        topics: [
          {
            name: "6.1 Gleichungslösung",
            href: "https://learning.casio-education.eu/c/#/activities/T355/C145679/C145691",
            items: [
              {
                name: "Lineare Gleichungen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145679|C145952/",
              },
              {
                name: "Quadratische Gleichungen I",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145679|C145961/",
              },
              {
                name: "Quadratische Gleichungen II",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145679|C145973/",
              },
              {
                name: "Quadratische Gleichungen III",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145679|C145967/",
              },
              {
                name: "Quadratische Gleichungen IV",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145679|C145979/",
              },
              {
                name: "Bruchgleichungen mit Modellen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145679|C145983/",
              },
              {
                name: "Bruchgleichungen ohne Hilfen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145679|C145987/",
              },
              {
                name: "Formeln umstellen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145679|C145691|C145991",
              },
            ],
          },
          {
            name: "6.2 Lineare Gleichungssystem",
            href: "https://learning.casio-education.eu/c/#/activities/T355/C145679/C145692",
            items: [
              {
                name: "LGS - Additionsmethode I",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145679|C145997/",
              },
              {
                name: "LGS - Subtraktionsmethode",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145679|C146004/",
              },
              {
                name: "LGS - Additionsmethode II",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145679|C146008/",
              },
              {
                name: "LGS - Einsetzungsmethode",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145679|C146013/",
              },
              {
                name: "LGS - graphische Lösung I",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145679|C146019/",
              },
              {
                name: "LGS - graphische Lösung II",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145679|C146025/",
              },
              {
                name: "LGS - Lösung mit GeoGebra",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145679|C146029/",
              },
              {
                name: "LGS - Lösung mit CAS",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145679|C146033/",
              },
              {
                name: "LGS - verschiedene Methoden",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145679|C146037/",
              },
              {
                name: "LGS - Textaufgaben",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T355/C145679|C146041/",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    nameOfClass: "Klasse 10 NEU",
    color: CARD_COLOR.GREEN,
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="86"
        height="81"
        viewBox="0 0 86 81"
        fill="none"
      >
        <path
          opacity="0.7"
          d="M42.1026 35.3771C43.9742 35.3771 45.7692 34.635 47.0926 33.3142C48.416 31.9933 49.1595 30.2019 49.1595 28.3339C49.1595 26.4659 48.416 24.6745 47.0926 23.3536C45.7692 22.0327 43.9742 21.2907 42.1026 21.2907C40.231 21.2907 38.4361 22.0327 37.1126 23.3536C35.7892 24.6745 35.0457 26.4659 35.0457 28.3339C35.0457 30.2019 35.7892 31.9933 37.1126 33.3142C38.4361 34.635 40.231 35.3771 42.1026 35.3771ZM42.1026 14.0864C43.9742 14.0864 45.7692 13.3443 47.0926 12.0235C48.416 10.7026 49.1595 8.91116 49.1595 7.04319C49.1595 5.17522 48.416 3.38376 47.0926 2.0629C45.7692 0.742048 43.9742 0 42.1026 0C40.231 0 38.4361 0.742048 37.1126 2.0629C35.7892 3.38376 35.0457 5.17522 35.0457 7.04319C35.0457 8.91116 35.7892 10.7026 37.1126 12.0235C38.4361 13.3443 40.231 14.0864 42.1026 14.0864ZM51.4989 63.7647C53.3705 63.7647 55.1655 63.0226 56.4889 61.7018C57.8123 60.3809 58.5558 58.5895 58.5558 56.7215C58.5558 54.8535 57.8123 53.062 56.4889 51.7412C55.1655 50.4203 53.3705 49.6783 51.4989 49.6783C49.6273 49.6783 47.8324 50.4203 46.5089 51.7412C45.1855 53.062 44.442 54.8535 44.442 56.7215C44.442 58.5895 45.1855 60.3809 46.5089 61.7018C47.8324 63.0226 49.6273 63.7647 51.4989 63.7647ZM32.4524 63.7647C34.3241 63.7647 36.1191 63.0226 37.4426 61.7017C38.7661 60.3807 39.5096 58.5892 39.5096 56.7211C39.5096 54.853 38.7661 53.0615 37.4426 51.7405C36.1191 50.4196 34.3241 49.6775 32.4524 49.6775C30.5806 49.6775 28.7856 50.4196 27.4621 51.7405C26.1386 53.0615 25.3951 54.853 25.3951 56.7211C25.3951 58.5892 26.1386 60.3807 27.4621 61.7017C28.7856 63.0226 30.5806 63.7647 32.4524 63.7647ZM27.1193 46.2759C28.9909 46.2759 30.7859 45.5338 32.1093 44.213C33.4327 42.8921 34.1762 41.1007 34.1762 39.2327C34.1762 37.3647 33.4327 35.5733 32.1093 34.2524C30.7859 32.9315 28.9909 32.1895 27.1193 32.1895C25.2477 32.1895 23.4527 32.9315 22.1293 34.2524C20.8059 35.5733 20.0624 37.3647 20.0624 39.2327C20.0624 41.1007 20.8059 42.8921 22.1293 44.213C23.4527 45.5338 25.2477 46.2759 27.1193 46.2759ZM7.05691 39.6859C7.98364 39.6859 8.90129 39.5037 9.75748 39.1498C10.6137 38.7958 11.3916 38.277 12.0469 37.623C12.7022 36.969 13.222 36.1926 13.5766 35.338C13.9313 34.4835 14.1138 33.5676 14.1138 32.6427C14.1138 31.7178 13.9313 30.8019 13.5766 29.9474C13.222 29.0929 12.7022 28.3165 12.0469 27.6624C11.3916 27.0084 10.6137 26.4896 9.75748 26.1357C8.90129 25.7817 7.98364 25.5995 7.05691 25.5995C5.1853 25.5995 3.39035 26.3416 2.06692 27.6624C0.743494 28.9833 0 30.7747 0 32.6427C0 34.5107 0.743494 36.3022 2.06692 37.623C3.39035 38.9439 5.1853 39.6859 7.05691 39.6859ZM63.9427 81C65.8144 81 67.6095 80.2579 68.933 78.937C70.2565 77.616 71 75.8245 71 73.9564C71 72.0883 70.2565 70.2968 68.933 68.9759C67.6095 67.6549 65.8144 66.9128 63.9427 66.9128C62.071 66.9128 60.2759 67.6549 58.9524 68.9759C57.6289 70.2968 56.8854 72.0883 56.8854 73.9564C56.8854 75.8245 57.6289 77.616 58.9524 78.937C60.2759 80.2579 62.071 81 63.9427 81ZM20.0086 81C21.8803 81 23.6754 80.2579 24.9989 78.937C26.3224 77.616 27.0659 75.8245 27.0659 73.9564C27.0659 72.0883 26.3224 70.2968 24.9989 68.9759C23.6754 67.6549 21.8803 66.9128 20.0086 66.9128C18.1369 66.9128 16.3418 67.6549 15.0183 68.9759C13.6948 70.2968 12.9513 72.0883 12.9513 73.9564C12.9513 75.8245 13.6948 77.616 15.0183 78.937C16.3418 80.2579 18.1369 81 20.0086 81ZM56.832 46.0224C58.7037 46.0224 60.4987 45.2803 61.8222 43.9594C63.1457 42.6385 63.8893 40.8469 63.8893 38.9788C63.8893 37.1108 63.1457 35.3192 61.8222 33.9983C60.4987 32.6774 58.7037 31.9353 56.832 31.9353C54.9603 31.9353 53.1652 32.6774 51.8417 33.9983C50.5182 35.3192 49.7747 37.1108 49.7747 38.9788C49.7747 40.8469 50.5182 42.6385 51.8417 43.9594C53.1652 45.2803 54.9603 46.0224 56.832 46.0224Z"
          fill="#63D7BD"
        />
        <path
          d="M77 40.9992C81.97 40.9992 86 37.1939 86 32.5C86 27.8053 81.97 24 77 24C72.0292 24 68 27.8053 68 32.5C68 37.1947 72.0292 40.9992 77 40.9992Z"
          fill="#20C5A0"
        />
      </svg>
    ),
    text: "Hier findet ihr Übungen für die Klassenstufe 10 für alle Schulformen in verschiedenen Schwierigkeitsgraden.",
    subjects: [
      {
        name: "1 Prozentrechnung",
        href: "",
        topics: [
          {
            name: "1.1 Prozent",
            href: "https://learning.casio-education.eu/c/#/activities/T356/C146082/C146089",
            items: [
              {
                name: "Rechnungen rund um Prozente I",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146082|C146101/",
              },
              {
                name: "Rechnungen rund um Prozente II",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146082|C146109/",
              },
            ],
          },
          {
            name: "1.2 Prozentsatz und Wachstumsfaktor",
            href: "https://learning.casio-education.eu/c/#/activities/T356/C146082/C146090",
            items: [
              {
                name: "Bestimme den Prozentfaktor",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146082|C146116/",
              },
              {
                name: "Berechnungen mit dem Prozentfaktor",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146082|C146124/",
              },
              {
                name: "Prozentrechnung mit Tabellenkalkulationen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146082|C146132/",
              },
            ],
          },
          {
            name: "1.3 Exponentielles Wachstum",
            href: "https://learning.casio-education.eu/c/#/activities/T356/C146082/C146091",
            items: [
              {
                name: "Exponentielles Wachstum",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146082|C146139/",
              },
              {
                name: "Exponentialfunktionen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146082|C146146/",
              },
            ],
          },
        ],
      },
      {
        name: "2 Wirtschaft",
        href: "",
        topics: [
          {
            name: "2.1 Persönliche Finanzen",
            href: "https://learning.casio-education.eu/c/#/activities/T356/C146083/C146092",
            items: [
              {
                name: "Umrechnung von Währungen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146083|C146151/",
              },
              {
                name: "Tabellenkalkulation lernen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146083|C146157/",
              },
              {
                name: "Sparen und Zinsen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146083|C146164/",
              },
              {
                name: "Verbraucherkredite und Kreditkarten",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146083|C146173/",
              },
              {
                name: "Budget und Konten",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146083|C146178/",
              },
            ],
          },
        ],
      },
      {
        name: "3 Funktionen",
        href: "",
        topics: [
          {
            name: "3.1 Verschiedene Arten von Funktionen",
            href: "https://learning.casio-education.eu/c/#/activities/T356/C146084/C146093",
            items: [
              {
                name: "Verschiedene Funktionstypen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146084|C146182/",
              },
              {
                name: "Spielen mit Funktionen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146084|C146188/",
              },
              {
                name: "Spiele mit Funktionen II",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146084|C146192/",
              },
              {
                name: "Funktionenmaschine",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146084|C146196/",
              },
            ],
          },
          {
            name: "3.2 Modellieren",
            href: "https://learning.casio-education.eu/c/#/activities/T356/C146084/C146094",
            items: [
              {
                name: "Sachkontexte",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146084|C146202/",
              },
              {
                name: "Modellieren",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146084|C146207/",
              },
              {
                name: "Lineare Regression mit GeoGebra",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146084|C146214/",
              },
            ],
          },
        ],
      },
      {
        name: "4 Zahlen und Mengen",
        href: "",
        topics: [
          {
            name: "4.1 Potenzen und Wurzeln",
            href: "https://learning.casio-education.eu/c/#/activities/T356/C146085/C146095",
            items: [
              {
                name: "Potenzgesetze",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146085|C146219/",
              },
              {
                name: "Rechnen mit Quadratwurzeln",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146085|C146227/",
              },
              {
                name: "wissenschaftliche Schreibweise",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146085|C146234/",
              },
            ],
          },
        ],
      },
      {
        name: "5 Trigonometrie",
        href: "",
        topics: [
          {
            name: "5.1 Trigonometrische Funktionen",
            href: "https://learning.casio-education.eu/c/#/activities/T356/C146086/C146096",
            items: [
              {
                name: "Tangens im rechtw. Dreieck",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146086|C146241/",
              },
              {
                name: "Sinus/Kosinus im rechtw. Dreieck",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146086|C146248/",
              },
              {
                name: "Seitenlängen im rechtw. Dreieck",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146086|C146255/",
              },
              {
                name: "Winkelmaße im rechtw. Dreieck",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146086|C146262/",
              },
            ],
          },
          {
            name: "5.2 Trigonometrie für allgemeine Dreiecke",
            href: "https://learning.casio-education.eu/c/#/activities/T356/C146086/C146097",
            items: [
              {
                name: "sin/cos/tan am Einheitskreis",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146086|C146270/",
              },
              {
                name: "Der Flächensatz",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146086|C146277/",
              },
              {
                name: "Der Sinussatz",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146086|C146284/",
              },
              {
                name: "Der Kosinussatz",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146086|C146291/",
              },
              {
                name: "Anwendungen der trigonometrischen Sätze",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146086|C146298/",
              },
            ],
          },
        ],
      },
      {
        name: "6 Prüfungsaufgaben",
        href: "",
        topics: [
          {
            name: "6.1 Gemischte Aufgaben",
            href: "https://learning.casio-education.eu/c/#/activities/T356/C146087/C146098",
            items: [
              {
                name: "Statistik",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146087|C146326/",
              },
              {
                name: "Zahlen verstehen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146087|C146330/",
              },
              {
                name: "Pythagoras",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146087|C146334/",
              },
              {
                name: "Karten und Bedingungen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146087|C146338/",
              },
              {
                name: "Geometrie",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146087|C146342/",
              },
              {
                name: "Funktionen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146087|C146346/",
              },
              {
                name: "Maßeinheiten",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146087|C146350/",
              },
              {
                name: "Algebra Grundlagen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146087|C146354/",
              },
              {
                name: "Algebra für Fortgeschrittene",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146087|C146358/",
              },
              {
                name: "Wahrscheinlichkeitsrechnung",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146087|C146362/",
              },
              {
                name: "Gleichungen Grundlagen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146087|C146366/",
              },
              {
                name: "Gleichungen für Fortgeschrittene",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146087|C146370/",
              },
              {
                name: "Gleichungssystem",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146087|C146374/",
              },
              {
                name: "Rechenreihenfolge, wissenschaftlich Schreibweise und Potenzen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146087|C146378/",
              },
              {
                name: "Schätzen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146087|C146382/",
              },
              {
                name: "Prozente",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146087|C146386/",
              },
              {
                name: "Bruchrechnung",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146087|C146390/",
              },
              {
                name: "Die vier Arten von Berechnungen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146087|C146394/",
              },
              {
                name: "Algebra und Erkundung",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146087|C146398/",
              },
              {
                name: "Das tägliche Leben und die Zahlen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146087|C146402/",
              },
              {
                name: "Wahrscheinlichkeitsrechnung",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146087|C146406/",
              },
              {
                name: "Funktionen und Graphen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146087|C146410/",
              },
              {
                name: "Geometrie",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146087|C146414/",
              },
              {
                name: "Statistik und Wirtschaft",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T356/C146087|C146418/",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    nameOfClass: "Klasse 11-12 NEU",
    color: CARD_COLOR.BLUE,
    svg: (
      <svg
        width="87"
        height="87"
        viewBox="95 85 115 62"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.7"
          d="M151.133 76.0444C155.662 76.0444 159.333 72.2584 159.333 67.5881C159.333 62.9178 155.662 59.1318 151.133 59.1318C146.604 59.1318 142.933 62.9178 142.933 67.5881C142.933 72.2584 146.604 76.0444 151.133 76.0444Z"
          fill="#02ACEC"
        />
        <path
          opacity="0.7"
          d="M129.181 82.0609C133.71 82.0609 137.381 78.2749 137.381 73.6047C137.381 68.9344 133.71 65.1484 129.181 65.1484C124.652 65.1484 120.981 68.9344 120.981 73.6047C120.981 78.2749 124.652 82.0609 129.181 82.0609Z"
          fill="#02ACEC"
        />
        <path
          opacity="0.7"
          d="M111.797 97.2821C116.325 97.2821 119.997 93.4961 119.997 88.8259C119.997 84.1556 116.325 80.3696 111.797 80.3696C107.268 80.3696 103.597 84.1556 103.597 88.8259C103.597 93.4961 107.268 97.2821 111.797 97.2821Z"
          fill="#02ACEC"
        />
        <path
          opacity="0.7"
          d="M103.596 119.607C108.125 119.607 111.796 115.821 111.796 111.151C111.796 106.48 108.125 102.694 103.596 102.694C99.0675 102.694 95.3962 106.48 95.3962 111.151C95.3962 115.821 99.0675 119.607 103.596 119.607Z"
          fill="#02ACEC"
        />
        <path
          opacity="0.7"
          d="M106.221 142.608C110.75 142.608 114.421 138.822 114.421 134.152C114.421 129.481 110.75 125.695 106.221 125.695C101.692 125.695 98.0209 129.481 98.0209 134.152C98.0209 138.822 101.692 142.608 106.221 142.608Z"
          fill="#02ACEC"
        />
        <path
          opacity="0.7"
          d="M118.686 161.888C123.215 161.888 126.886 158.102 126.886 153.432C126.886 148.762 123.215 144.976 118.686 144.976C114.157 144.976 110.486 148.762 110.486 153.432C110.486 158.102 114.157 161.888 118.686 161.888Z"
          fill="#02ACEC"
        />
        <path
          opacity="0.7"
          d="M139.021 173.05C143.549 173.05 147.221 169.264 147.221 164.594C147.221 159.924 143.549 156.138 139.021 156.138C134.492 156.138 130.821 159.924 130.821 164.594C130.821 169.264 134.492 173.05 139.021 173.05Z"
          fill="#02ACEC"
        />
        <path
          opacity="0.7"
          d="M161.978 173.727C166.507 173.727 170.178 169.941 170.178 165.271C170.178 160.6 166.507 156.814 161.978 156.814C157.449 156.814 153.778 160.6 153.778 165.271C153.778 169.941 157.449 173.727 161.978 173.727Z"
          fill="#02ACEC"
        />
        <path
          opacity="0.7"
          d="M182.316 162.903C186.844 162.903 190.516 159.117 190.516 154.446C190.516 149.776 186.844 145.99 182.316 145.99C177.787 145.99 174.116 149.776 174.116 154.446C174.116 159.117 177.787 162.903 182.316 162.903Z"
          fill="#02ACEC"
        />
        <path
          opacity="0.7"
          d="M198.717 120.622C203.245 120.622 206.917 116.836 206.917 112.166C206.917 107.495 203.245 103.709 198.717 103.709C194.188 103.709 190.517 107.495 190.517 112.166C190.517 116.836 194.188 120.622 198.717 120.622Z"
          fill="#02ACEC"
        />
        <path
          opacity="0.7"
          d="M190.516 98.2973C195.045 98.2973 198.716 94.5113 198.716 89.841C198.716 85.1708 195.045 81.3848 190.516 81.3848C185.987 81.3848 182.316 85.1708 182.316 89.841C182.316 94.5113 185.987 98.2973 190.516 98.2973Z"
          fill="#02ACEC"
        />
        <path
          opacity="0.7"
          d="M174.115 82.0609C178.644 82.0609 182.315 78.2749 182.315 73.6047C182.315 68.9344 178.644 65.1484 174.115 65.1484C169.586 65.1484 165.915 68.9344 165.915 73.6047C165.915 78.2749 169.586 82.0609 174.115 82.0609Z"
          fill="#02ACEC"
        />
        <path
          d="M196.257 145.99C201.963 145.99 206.589 141.22 206.589 135.336C206.589 129.451 201.963 124.681 196.257 124.681C190.55 124.681 185.925 129.451 185.925 135.336C185.925 141.22 190.55 145.99 196.257 145.99Z"
          fill="#02ACEC"
        />
      </svg>
    ),
    text: "Hier findet ihr Übungen für die Klassenstufe 11-12 für alle Schulformen in verschiedenen Schwierigkeitsgraden.",
    subjects: [
      {
        name: "1 Zahlen and Mengen",
        href: "",
        topics: [
          {
            name: "1.1 Grundlagen",
            href: "https://learning.casio-education.eu/c/#/activities/T357/C146540/C146546",
            items: [
              {
                name: "Zahlenmengen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146540|C146573/",
              },
              {
                name: "Intervalle",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146540|C146580/",
              },
              {
                name: "Terme und Gleichungen mit CAS",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146540|C146587/",
              },
            ],
          },
          {
            name: "1.2 Potenzen und Wurzeln",
            href: "https://learning.casio-education.eu/c/#/activities/T357/C146540/C146547",
            items: [
              {
                name: "Potenzgesetze (11)",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146540|C146594/",
              },
              {
                name: "Potenzgesetze (12)",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146540|C149744/",
              },
              {
                name: "Rechenregeln für Quadratwurzeln",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146540|C146602/",
              },
              {
                name: "Wissenschaftliche Schreibweise",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146540|C146609/",
              },
              {
                name: "Wurzeln und Potenzen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146540|C149751/",
              },
            ],
          },
          {
            name: "1.3 Logarithmen",
            href: "https://learning.casio-education.eu/c/#/activities/T357/C146540/C149740",
            items: [
              {
                name: "Definition Logarithmus",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146540|C149759/",
              },
              {
                name: "Natürlicher Logarithmus",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146540|C149766/",
              },
              {
                name: "Logarithmengesetze",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146540|C149773/",
              },
            ],
          },
        ],
      },
      {
        name: "2 Algebraische Ausdrücke",
        href: "",
        topics: [
          {
            name: "2.1 Variablenrechnung",
            href: "https://learning.casio-education.eu/c/#/activities/T357/C146541/C146548",
            items: [
              {
                name: "Termumformungen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146541|C146616/",
              },
              {
                name: "Äquivalente Ausdrücke",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146541|C146624/",
              },
            ],
          },
          {
            name: "2.2 Faktorisierung und Vereinfachung",
            href: "https://learning.casio-education.eu/c/#/activities/T357/C146541/C146549",
            items: [
              {
                name: "Klammern auflösen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146541|C146632/",
              },
              {
                name: "Faktorisieren",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146541|C146639/",
              },
              {
                name: "Binomische Formeln",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146541|C146646/",
              },
              {
                name: "Faktorisieren mit Bin. Formeln",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146541|C146654/",
              },
              {
                name: "Quadratische Ergänzung I",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146541|C146662/",
              },
              {
                name: "Quadratische Ergänzung II",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146541|C146669/",
              },
              {
                name: "Vereinfachung von Bruchtermen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146541|C146676/",
              },
            ],
          },
          {
            name: "2.3 Quadratische und Bruchterme",
            href: "https://learning.casio-education.eu/c/#/activities/T357/C146541/C146550",
            items: [
              {
                name: "Anwendungen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146541|C146683/",
              },
              {
                name: "Mustererkennung",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146541|C146690/",
              },
            ],
          },
        ],
      },
      {
        name: "3 Gleichungen",
        href: "",
        topics: [
          {
            name: "3.1 Gleichungen",
            href: "https://learning.casio-education.eu/c/#/activities/T357/C146542/C146551",
            items: [
              {
                name: "Elementare Gleichungen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146542|C146697/",
              },
              {
                name: "Umstellung von Formeln",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146542|C146705/",
              },
              {
                name: "Quadr. Gleichungen lösen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146542|C146712/",
              },
              {
                name: "Rationale Gleichungen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146542|C146719/",
              },
              {
                name: "Exponentialgleichungen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146542|C149804/",
              },
              {
                name: "Weitere Exponentialgleichungen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146542|C149822/",
              },
              {
                name: "Logarithmische Gleichungen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146542|C149783/",
              },
              {
                name: "Weitere log. Gleichungen (adv.)",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146542|C149790/",
              },
            ],
          },
          {
            name: "3.2 Gleichungssysteme",
            href: "https://learning.casio-education.eu/c/#/activities/T357/C146542/C146552",
            items: [
              {
                name: "LGS - grafische Lösungen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146542|C146726/",
              },
              {
                name: "LGS - Lösen mit und ohne CAS",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146542|C146733/",
              },
              {
                name: "LGS - Anwendungen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146542|C146747/",
              },
              {
                name: "Nichtlineare Gleichungssysteme",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146542|C146740/",
              },
            ],
          },
          {
            name: "3.3 Ungleichungen",
            href: "https://learning.casio-education.eu/c/#/activities/T357/C146542/C149842",
            items: [
              {
                name: "Quadr. Ungleichungen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146542|C149844/",
              },
              {
                name: "Gebrochenrationale Ungleichungen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146542|C149851/",
              },
              {
                name: "Exponentielle Ungleichungen (adv.)",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146542|C149829/",
              },
              {
                name: "Logarithmische Ungleichungen (adv.)",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146542|C149797/",
              },
            ],
          },
        ],
      },
      {
        name: "4 Funktionen",
        href: "",
        topics: [
          {
            name: "4.1 Der Funktionsbegriff",
            href: "https://learning.casio-education.eu/c/#/activities/T357/C146543/C146553",
            items: [
              {
                name: "Funktionen und Funktionsterme",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146543|C146754/",
              },
              {
                name: "Der Graph einer Funktion",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146543|C146761/",
              },
              {
                name: "Funktionsgraphen mit GeoGebra",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146543|C146768/",
              },
              {
                name: "Nullstellen und Schnittpunkte",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146543|C146777/",
              },
              {
                name: "Stückweise definierte Fkt.",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146543|C149885/",
              },
              {
                name: "Stetige Funktionen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146543|C146836/",
              },
            ],
          },
          {
            name: "4.2 Polynomfunktionen",
            href: "https://learning.casio-education.eu/c/#/activities/T357/C146543/C146554",
            items: [
              {
                name: "Lineare Funktionen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146543|C146784/",
              },
              {
                name: "Quadratische Funktionen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146543|C146792/",
              },
              {
                name: "Potenzfunktionen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146543|C146812/",
              },
              {
                name: "Ganzrationale Funktionen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146543|C146799/",
              },
              {
                name: "Ganzr. Funktionen n-ten Grades",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146543|C146805/",
              },
            ],
          },
          {
            name: "4.3 Exp.- und Log.-Funktionen",
            href: "https://learning.casio-education.eu/c/#/activities/T357/C146543/C150193",
            items: [
              {
                name: "Wachstumsfaktor (rep.)",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146543|C149864/",
              },
              {
                name: "Exponentialfunktionen 1",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146543|C149871/",
              },
              {
                name: "Exponentialfunktionen 2",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146543|C149892/",
              },
              {
                name: "Logarithmusfunktionen (adv.)",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146543|C149899/",
              },
            ],
          },
          {
            name: "4.4 Grenzwerte",
            href: "https://learning.casio-education.eu/c/#/activities/T357/C146543/C149742",
            items: [
              {
                name: "Das Grenzwertkonzept",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146543|C149906/",
              },
              {
                name: "Grenzwerte bestimmen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146543|C149913/",
              },
              {
                name: "Asymptoten 1 (adv.)",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146543|C149927/",
              },
              {
                name: "Asymptoten 2",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146543|C149934/",
              },
              {
                name: "Gebrochen rationale Funktionen (adv.)",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146543|C149941/",
              },
            ],
          },
        ],
      },
      {
        name: "5 Analysis und Ableitung",
        href: "",
        topics: [
          {
            name: "5.1 Änderungsrate und Ableitung",
            href: "https://learning.casio-education.eu/c/#/activities/T357/C146544/C146558",
            items: [
              {
                name: "Durchschnittliche Änderungsrate",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146544|C146843/",
              },
              {
                name: "Momentane Änderungsrate",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146544|C146850/",
              },
              {
                name: "Änderungsrate und Ableitung I",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146544|C146864/",
              },
              {
                name: "Differenzierbarkeit",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146544|C146871/",
              },
            ],
          },
          {
            name: "5.2 Ableitung von Funktionen",
            href: "https://learning.casio-education.eu/c/#/activities/T357/C146544/C146559",
            items: [
              {
                name: "Änderungsrate und Ableitung II",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146544|C146878/",
              },
              {
                name: "Änderungsrate und Ableitung III",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146544|C146885/",
              },
              {
                name: "Ableitung linearer Funktionen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146544|C146892/",
              },
              {
                name: "Ableitung Potenzfunktionen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146544|C146899/",
              },
              {
                name: "Ableitung Polynomfunktionen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146544|C146906/",
              },
              {
                name: "Ableitung exp(x) und ln(x)",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146544|C149953/",
              },
              {
                name: "Kettenregel",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146544|C149960/",
              },
              {
                name: "Die Produktregel",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146544|C149967/",
              },
              {
                name: "Die Quotientenregel",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146544|C149974/",
              },
            ],
          },
          {
            name: "5.3 Fkt-Untersuchungen",
            href: "https://learning.casio-education.eu/c/#/activities/T357/C146544/C150194",
            items: [
              {
                name: "Monotonie",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146544|C146857/",
              },
              {
                name: "Untersuchung von Funktionen I",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146544|C146913/",
              },
              {
                name: "Untersuchung von Funktionen II",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146544|C146920/",
              },
              {
                name: "Untersuchung von Funktionen III",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146544|C146927/",
              },
              {
                name: "Wendepunkt und -tangente",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146544|C149995/",
              },
              {
                name: "Krümmung",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146544|C149988/",
              },
              {
                name: "Prüfungsaufgaben",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146544|C150002/",
              },
            ],
          },
          {
            name: "5.4 Umkehrfunktionen",
            href: "https://learning.casio-education.eu/c/#/activities/T357/C146544/C151024",
            items: [
              {
                name: "Umkehrfunktionen I",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146544|C150014/",
              },
              {
                name: "Umkehrfunktionen II",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146544|C150007/",
              },
              {
                name: "Ableitung mittels Umkehrfunkt.",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146544|C150021/",
              },
            ],
          },
        ],
      },
      {
        name: "6 Modellieren",
        href: "",
        topics: [
          {
            name: "6.1 Modellieren",
            href: "https://learning.casio-education.eu/c/#/activities/T357/C149685/C146556",
            items: [
              {
                name: "Modellieren mit Funktionstermen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C149685|C146817/",
              },
              {
                name: "Lineare Regression",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C149685|C146824/",
              },
              {
                name: "Nichtlineare Regression",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C149685|C146831/",
              },
            ],
          },
          {
            name: "6.2 Wachstumsmodelle",
            href: "https://learning.casio-education.eu/c/#/activities/T357/C149685/C150035",
            items: [
              {
                name: "Exp. und lin. Wachstum",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C149685|C150043/",
              },
              {
                name: "Logistisches Wachstum",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C149685|C150050/",
              },
              {
                name: "Regression und Modellwahl",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C149685|C150057/",
              },
            ],
          },
        ],
      },
      {
        name: "7 Vektoren",
        href: "",
        topics: [
          {
            name: "7.1 Vektoren",
            href: "https://learning.casio-education.eu/c/#/activities/T357/C146545/C146561",
            items: [
              {
                name: "Vektoren als Pfeile",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146545|C146940/",
              },
              {
                name: "Vektoren in Koordinatenform",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146545|C146947/",
              },
              {
                name: "Addition/Subtraktion als Pfeile",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146545|C146954/",
              },
              {
                name: "Add./Subt. in Koordinatenform",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146545|C146961/",
              },
              {
                name: "Vereinfachung von Vektortermen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146545|C146968/",
              },
            ],
          },
          {
            name: "7.2 Rechnen mit Vektoren",
            href: "https://learning.casio-education.eu/c/#/activities/T357/C146545/C146563",
            items: [
              {
                name: "Parallele Vektoren",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146545|C146974/",
              },
              {
                name: "Skalarmultiplikation",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146545|C146981/",
              },
              {
                name: "Länge von Vektoren",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146545|C146988/",
              },
              {
                name: "Mittelpunkt einer Strecke",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146545|C146995/",
              },
            ],
          },
          {
            name: "7.3 Geraden und Kreise",
            href: "https://learning.casio-education.eu/c/#/activities/T357/C146545/C146564",
            items: [
              {
                name: "Parameterdarstellung von Geraden",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146545|C147002/",
              },
              {
                name: "Die Kreisgleichung",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146545|C150078/",
              },
            ],
          },
          {
            name: "7.4 Skalarprodukt",
            href: "https://learning.casio-education.eu/c/#/activities/T357/C146545/C150037",
            items: [
              {
                name: "Definition des Skalarprodukt",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146545|C150064/",
              },
              {
                name: "Skalarprodukt/Koordinatenform",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146545|C150071/",
              },
            ],
          },
          {
            name: "7.5 Vektorfunktionen",
            href: "https://learning.casio-education.eu/c/#/activities/T357/C146545/C150039",
            items: [
              {
                name: "Parameterdarstellungen",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C146545|C150086/",
              },
            ],
          },
        ],
      },
      {
        name: "8 Stochastik",
        href: "",
        topics: [
          {
            name: "8.1 Zweistufige Zufallsversuche",
            href: "https://learning.casio-education.eu/c/#/activities/T357/C149687/C150040",
            items: [
              {
                name: "Vier-Felder-Tafel/Baumdiagramm",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C149687|C150098/",
              },
              {
                name: "Unabhängige Ereignisse",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C149687|C150104/",
              },
              {
                name: "Abhängige Ereignisse",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C149687|C150110/",
              },
            ],
          },
          {
            name: "8.2 Kombinatorik",
            href: "https://learning.casio-education.eu/c/#/activities/T357/C149687/C150041",
            items: [
              {
                name: "Fakultät und Binomialkoeff.",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C149687|C150116/",
              },
              {
                name: "Geordnete Stichproben",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C149687|C150122/",
              },
              {
                name: "Ungeordnete Stichproben",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C149687|C150128/",
              },
            ],
          },
          {
            name: "8.3 Verteilungen",
            href: "https://learning.casio-education.eu/c/#/activities/T357/C149687/C150042",
            items: [
              {
                name: "Hypergeometrische Wahrsch.",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C149687|C150134/",
              },
              {
                name: "Binomialwahrscheinlichkeit",
                href: "https://learning.casio-education.eu/c/#/calculation/t/T357/C149687|C150140/",
              },
            ],
          },
        ],
      },
    ],
  },
];
